module.exports = __webpack_public_path__ + "static/eco_safe-1a0786a347f406fed5eb0abedf3b05f7.png";